import { render, staticRenderFns } from "./select-portrait.vue?vue&type=template&id=76d070bc&scoped=true&"
import script from "./select-portrait.vue?vue&type=script&lang=ts&"
export * from "./select-portrait.vue?vue&type=script&lang=ts&"
import style0 from "./select-portrait.vue?vue&type=style&index=0&id=76d070bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d070bc",
  null
  
)

export default component.exports